<template>
    <!-- Helpers to generate WaveSurfer.js waves. not visible -->
    <div id="canvas">
        <div id="waveform-container" :style="waveformContainerStyle">
            <div id="waveform-0"></div>
            <div id="waveform-1"></div>
            <div id="waveform-2"></div>
            <div id="waveform-3"></div>
            <div id="waveform-4"></div>
        </div>
    </div>
</template>


<script type="text/javascript">
import { mapFields } from 'vuex-map-fields';

export default {
    computed: {
        ...mapFields([
            'waveformContainerStyle'
        ])
    }
}
</script>
